import type { CMSConfig } from '#types/config/components/cms'

export default {
  provider: 'curalate'
} satisfies CMSConfig['ugc']
